import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';

import { MonthPickerDOS } from './month-picker-dos.service';

@Component({
  selector: 'app-custom-datepicker-header',
  templateUrl: './custom-datepicker-header.component.html',
  styleUrls: ['./custom-datepicker-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomDatepickerHeaderComponent {
  constructor(
    private calendar: MatCalendar<Date>,
    private dateAdapter: DateAdapter<Date>,
    private _monthPickerDOS: MonthPickerDOS
  ) {}

  get periodLabel(): number {
    return this.calendar.activeDate.getFullYear();
  }

  previousClicked(): void {
    this.calendar.activeDate = this.dateAdapter.addCalendarYears(this.calendar.activeDate, -1);
    this.handlePanelClass();
  }

  nextClicked(): void {
    this.calendar.activeDate = this.dateAdapter.addCalendarYears(this.calendar.activeDate, 1);
    this.handlePanelClass();
  }

  handlePanelClass(): void {
    if (this.calendar.activeDate.getFullYear() !== this.calendar.startAt.getFullYear()) {
      this._monthPickerDOS.changePanelClass('custom-datepicker');
    } else {
      this._monthPickerDOS.changePanelClass('custom-datepicker current-year');
    }
  }
}
